export const Constants = {
  TAG_NAME: 'pop-overview-component',
  NESTED_COMPONENTS: [
    'pop-overview-key-facts-component',
    'pop-team-member-component',
  ],
  OVERVIEW: 'Overview',
  OVERVIEW_UNAVAILABLE: 'Overview unavailable',
  STRATEGY: 'Strategy',
} as const;
